// @noflow
import React from 'react';
import ConfettiFramedContainerKiwibank from '../ConfettiFramedContainer/ConfettiFramedContainerKiwibank';
import EstimateRateWidget from './EstimateRateWidgetKiwibank';
import { EstimateRateWidgetSectionWrapper } from './EstimateRateWidget.styled';

interface Props {
  purpose?: string;
  loanAmount?: number;
  repaymentPeriod?: number;
  purposeOther?: string;
  trackProductId?: Array<string>;
}

const EstimateRateWidgetSectionKiwibank = (props: Props) => (
  <EstimateRateWidgetSectionWrapper id="check-your-rate">
    <ConfettiFramedContainerKiwibank>
      <EstimateRateWidget
        defaultPurpose={props.purpose}
        defaultPurposeOther={props.purposeOther}
        defaultLoanAmount={props.loanAmount}
        defaultRepaymentPeriod={props.repaymentPeriod}
        trackProductId={props.trackProductId}
      />
    </ConfettiFramedContainerKiwibank>
  </EstimateRateWidgetSectionWrapper>
  );

export default EstimateRateWidgetSectionKiwibank;
